<template>
  <nav class="pagination">
    <a class="pagination-previous" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1">Previous</a>
    <ul class="pagination-list">
      <li>
      <a class="pagination-link" v-for="page in totalPages" :key="page" @click="changePage(page)" :disabled="page === currentPage">
        {{ page }}
      </a>
      </li>
    </ul>
    <a class="pagination-next"  @click="changePage(currentPage + 1)" :disabled="currentPage >= totalPages">Next</a>
  </nav>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    totalItems: Number,
    pageSize: Number
  },
  computed: {
    totalPages () {
      return Math.ceil(this.totalItems / this.pageSize)
    }
  },
  methods: {
    changePage (page) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit('page-change', page)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue